
<template lang="pug">
    el-container(v-loading.fullscreen.lock="loading").has-centered-content
        .panel-container
            p.message {{ $t('Processing Login with UPS') }}.
</template>

<i18n>
{
  "de": {
    "Logged in with UPS successfully!": "Erfolgreich mit UPS eingeloggt!",
    "An error occurred!": "Es ist ein Fehler aufgetreten!",
    "Login with UPS failed": "Login mit UPS ist fehlgeschlagen",
    "Processing Login with UPS": "Login per UPS wird verarbeitet"
  }
}
</i18n>

<script>

import _ from 'lodash'

import axios from 'axios';
import UPS from '@/extensions/shop/pointOfSale/store/api/ups'
import router from '@/router';

export default {
    name: 'UpsRedirect',
    data() {
        return {
            loading: true,
        };
    },
    methods: {
        getAccessToken() {
            const endpoint = process.env.VUE_APP_API_ENDPOINT + "ups/token";
            const payload = { authCode: this.$route.query.code, redirectUri: process.env.VUE_APP_UPS_REDIRECT_URI }
            axios.post(endpoint, payload)
                .then(({ data }) => {
                    UPS.setToken(JSON.stringify(data));
                    this.loading = false

                    this.$notify.success({
                        title: this.$t('Logged in with UPS successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });


                    let upsLoginStatus = JSON.parse(localStorage.getItem("upsLoginStatus"));
                    if (upsLoginStatus) {
                        router.push({ path: upsLoginStatus.url })
                    }

                })
                .catch(error => {
                    console.error(error)
                    this.rendering.receipt = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Login with UPS failed'),
                        iconClass: 'fas el-icon-fa-xmark',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        }
    },
    mounted() {
        this.getAccessToken();
    }
}
</script>

<style lang="sass" scoped>
.message
    padding: 20px
    font-size: 24px
</style>
